module.exports = __webpack_public_path__ + "img/template_3.d12f95e0.png";